export const EXTERNAL_ID_TOKEN = 'inroExternalIdToken';
export const EXTERNAL_CURRENT_USER = 'inroExternalCurrentUser';
export const EXT_TOKEN_CREATION = 'inroExtTokenCreation';
export const EXTERNAL_ID_TOKEN_HASH = 'inroExternalIdTokenHash';